import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Layout from 'components/Layout';
import Header from 'components/Header';
import Container from 'components/Pages/ProfileEdit/Container';
import { selectQuestionnaireNextQuestion } from 'actions/questionnaire';
import { hideModal } from 'actions/modal';

const Edit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(selectQuestionnaireNextQuestion(null));
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <Layout title="Edit profile | GMB Fitness™">
      <Header backTo="/profile" backTitle="Back to overview" />
      <Container />
    </Layout>
  );
};

export default Edit;
